// Where a guardian lands after the concierge pay link (spec 2026-11-03-concierge-stripe-payments §3).
// Public: the guardian is not signed in, so App.js declares this route with no
// Layout or login guard. The backend's pay link redirects here with ?status=…;
// the page only reports that outcome. Fulfillment happens on the webhook, never here.
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './PublicCampRegister.css';

const MESSAGES = {
  paid: "Thank you — your payment went through. You'll get a receipt by email.",
  cancelled: 'Payment cancelled. You can use the link in your email any time.',
  already_paid: 'This payment has already been made.',
  invalid: 'This payment link is no longer valid.',
  unavailable: "Payment isn't available right now. Please contact the person who sent this.",
  error: 'Something went wrong. Please try the link again.',
};

export default function ConciergePaymentDonePage() {
  const [params] = useSearchParams();
  const message = MESSAGES[params.get('status')] || MESSAGES.error;

  useEffect(() => { document.title = 'Payment | ProZpects'; }, []);

  return (
    <div className="pcr-shell">
      <div className="pcr-card pcr-card--notice">
        <img src="/logo-wordmark.png" alt="ProZpects" className="pcr-logo" />
        <p>{message}</p>
      </div>
    </div>
  );
}
